import { FormValidatorNames, IFormLayout } from '@/uikit/forms/NForm.vue';
import NInput from '@/uikit/input/NInput.vue';
import NSwitch from '@/uikit/switch/NSwitch.vue';
import ButtonModelCopy from '@/components/common/ButtonModelCopy.vue';
import { getItemCommonFields } from '@/components/common/get-item-common-fields';
import CameraGroupName from '@/components/data-source/CameraGroupName.vue';
import CameraScreenshot from '@/components/data-source/CameraScreenshot.vue';

export const dataSourceGeneralExternalDetector: IFormLayout = [
  {
    path: 'screenshot',
    classes: 'label-m n-form-w-12 n-form-pad-10',
    component: CameraScreenshot,
    props: { width: 520, displayWidth: '520px', hasPlay: false }
  },
  [
    {
      path: 'name',
      classes: 'n-form-w-3 n-form-pad-10',
      i18n_label: 'ds.external_detector_name',
      component: NInput,
      validators: [{ name: FormValidatorNames.Required }]
    },
    {
      path: 'group',
      classes: 'n-form-w-3 n-form-pad-10',
      i18n_label: 'ds.external_detector_camera_group',
      component: CameraGroupName
    }
  ],
  {
    path: 'comment',
    classes: 'n-form-w-6 n-form-pad-10',
    i18n_label: 'ds.description',
    component: NInput
  },
  {
    classes: 'n-form-w-2 n-form-pad-10 n-form-min-h-30 n-form-vcenter',
    component: NSwitch,
    path: 'stream_settings.enable_liveness',
    props: { i18n_label: 'ds.enable_liveness' }
  },

  {
    path: 'external_detector_token',
    classes: 'n-form-w-6 n-form-pad-10',
    i18n_label: 'ds.external_detector_token',
    component: ButtonModelCopy,
    props: { hintPlacement: 'left' }
  },
  ...getItemCommonFields()
];
